module.exports = __webpack_public_path__ + "img/sideflag.d4aac5e.png";